import { request } from 'api/request';
import {
  ActionRelationship,
  BASE_ACTION_TYPE,
  TravellerJourneyAction,
  TravellerJourneyActionDetailed,
} from 'api/types';

export const loadTravellerActions = async (travellerJourneyShortId: string) => {
  const response = await request.get<TravellerJourneyAction[]>(
    `v1/traveller-actions/?traveller_journey=${travellerJourneyShortId}`
  );
  return response.data;
};

export const listTravellerActionRelationships = async (shortId: string) => {
  const response = await request.get<ActionRelationship>(
    `v1/traveller-actions/relationships/?traveller_action=${shortId}`
  );
  return response.data;
};

export const createTravellerActionRelationship = async (data: {
  parentAction: string;
  childAction: string;
}) => {
  const response = await request.post('v1/traveller-actions/relationships/', data);
  return response.data;
};

export const removeTravellerActionRelationship = async (shortId: string) => {
  const response = await request.delete(`v1/traveller-actions/relationships/${shortId}/`);
  return response.data;
};

export const loadJourneyTravellerAction = async <ActionType extends BASE_ACTION_TYPE>(
  id: string
) => {
  const response = await request.get<TravellerJourneyActionDetailed<ActionType>>(
    `v1/traveller-actions/${id}/`
  );
  return response.data;
};

export type TravellerActionGroupAction = {
  shortId: string;
  action: BASE_ACTION_TYPE;
  isDisabled: boolean;
  status?: TravellerJourneyAction['status'];
  result?: TravellerJourneyAction['result'];
};

export const runJourneyTravellerAction = async (id: string) => {
  const response = await request.post(`v1/traveller-actions/${id}/run`);
  return response.data;
};

export const updateJourneyTravellerAction = async (id: string, data: any) => {
  const response = await request.patch(`v1/traveller-actions/${id}/`, {
    ...data,
    saved_values: {}, // when editing an action we want to clear saved_values so the new values will be used the next time it is run
  });
  return response.data;
};

export const unskipJourneyTravellerAction = async (actionId: TravellerJourneyAction['shortId']) => {
  const response = await request.delete(`v1/traveller-actions/${actionId}/skip/`);
  return response.data;
};

export const skipJourneyTravellerAction = async (actionId: TravellerJourneyAction['shortId']) => {
  const response = await request.post(`v1/traveller-actions/${actionId}/skip/`);
  return response.data;
};

export const listBreakingReferencesBySkip = async (actionId: TravellerJourneyAction['shortId']) => {
  const response = await request.get<string[]>(`v1/traveller-actions/${actionId}/skip/`);
  return response.data;
};

export const resetActionsFromHere = async (actionId: TravellerJourneyAction['shortId']) => {
  const response = await request.post(`v1/traveller-actions/${actionId}/reset-from-here/`);
  return response.data;
};
